import React, { useEffect } from 'react';
import { useParams, useHistory, useLocation } from 'react-router-dom';
import { TriageManager } from 'app/lib/triage/TriageManager';

export const getServiceSlugsEligibleForTriage = (): string[] => {
  // Passing in an empty string for `userId` because we only want the
  // remote variables from Optimizely and not any bucketing behavior.
  const enabled = window.optimizelyClientInstance.isFeatureEnabled('SERVICES_ELIGIBLE_FOR_TRIAGE', '');

  if (!enabled) {
    return [];
  }

  const serviceSlugs: string = window.optimizelyClientInstance.getFeatureVariableString(
    'SERVICES_ELIGIBLE_FOR_TRIAGE',
    'serviceSlugs',
    ''
  );

  return serviceSlugs.split(',');
};

const Triage = () => {
  const { slug } = useParams<{ slug: string }>();
  const history = useHistory();

  const slugs = getServiceSlugsEligibleForTriage();
  const { state } = useLocation<{ referrerPage: string }>();

  const hasStartedTriage = !!sessionStorage.getItem('triageCache');
  const isEligible = slugs.includes(slug!) && (state?.referrerPage === 'start' || hasStartedTriage);

  useEffect(() => {
    if (!isEligible && slug) {
      history.replace(`/start/${slug}`);
    }
  }, [isEligible, slug]);

  return isEligible ? <TriageManager /> : null;
};

export default Triage;
